import { useState, useEffect } from 'react';

const Placeholder = ({
  messages,
  loop = true,
  defaultText = '',
  pauseTime = 1000,
  finalPauseTime = 10000,
}) => {
  const [placeholder, setPlaceholder] = useState('');
  const [index, setIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showDefault, setShowDefault] = useState(false);

  useEffect(() => {
    if (showDefault) {
      setPlaceholder(defaultText);
      const timer = setTimeout(() => {
        setShowDefault(false);
        if (loop) {
          setIndex(0);
          setCharIndex(0);
          setIsDeleting(false);
        } else if (!loop) {
            return;
        }
      }, finalPauseTime);
      return () => clearTimeout(timer);
    }

    const currentText = messages[index];
    const speed = isDeleting ? 50 : 120;

    const timeout = setTimeout(() => {
      if (isDeleting) {
        setPlaceholder(currentText.substring(0, charIndex - 1));
        setCharIndex((prev) => prev - 1);
      } else {
        setPlaceholder(currentText.substring(0, charIndex + 1));
        setCharIndex((prev) => prev + 1);
      }

      if (!isDeleting && charIndex === currentText.length) {
        setTimeout(() => setIsDeleting(true), pauseTime);
      } else if (isDeleting && charIndex === 0) {
        if (index === messages.length - 1) {
          setShowDefault(true);
        } else {
          setIsDeleting(false);
          setIndex((prev) => prev + 1);
        }
      }
    }, speed);

    return () => clearTimeout(timeout);
  }, [
    charIndex,
    isDeleting,
    index,
    messages,
    loop,
    defaultText,
    pauseTime,
    finalPauseTime,
    showDefault,
  ]);

  return placeholder;
};

export default Placeholder;
